import Component from '../core/Component'
import Flickity from 'flickity-sync'
import { queryAll, toggleClass } from '../utils/dom'


let hidden, visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    hidden = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

export default class HomepageVisual extends Component {
    constructor(element){
        super(element)

        this.ref = {
            sliders: [],
            dots: [],
            caption: null,
            title: null
        }

        this.sliders = []
        this.timer = null
        this.delay = 4250
    }

    prepare() {
        this.sliders = this.ref.sliders
            .map((element, index) => {
                const slider = Component.getFromElement(element)

                if (index === 0) {
                    slider.on('change', this.handleChange)
                    slider.on('dragStart', this.handleDragStart)
                    slider.on('dragEnd', this.handleDragEnd)
                }

                element.addEventListener('mouseenter', this.handleMouseEnter)
                element.addEventListener('mouseleave', this.handleMouseLeave)

                return slider
            })

        this.captionSlider = Component.getFromElement(this.ref.caption)
        this.titleSlider = Component.getFromElement(this.ref.title)

        this.ref.dots.forEach((element, index) => element.addEventListener('click', this.handleDotClick))

        document.addEventListener(visibilityChange, this.handleVisibilityChange)

        this.start()
    }

    destroy() {
        this.stop()
        this.sliders = []
        document.removeEventListener(visibilityChange, this.handleVisibilityChange)
    }

    handleVisibilityChange = event => {
        if (document[hidden]) {
            this.stop()
        } else {
            this.start()
        }
    }

    handleDragStart = () => {
        this.stop()
    }

    handleDragEnd = () => {
        this.start()
    }

    handleMouseEnter = () => {
        this.stop()
    }

    handleMouseLeave = () => {
        this.start()
    }

    handleChange = ({ index: currentIndex }) => {
        this.ref.dots.forEach((dot, index) => toggleClass(dot, 'is-active', index === currentIndex))
        this.captionSlider?.select(currentIndex)
        this.titleSlider?.next()
    }

    handleDotClick = event => {
        const index = this.ref.dots.indexOf(event.target)
        this.stop()
        this.show(index)
        this.start()
    }

    start() {
        clearInterval(this.timer)
        this.timer = setInterval(() => this.sliders[0]?.next(), this.delay)
    }

    stop() {
        clearInterval(this.timer)
    }

    show(index) {
        this.sliders[0]?.select(index)
    }

}
